<template>
    <div :class="['input-single', {error: errors.has(name)}, styleclass]">
        <label class="radio-label">
            <input @change="change" :type="type" :name="name" :required="required" :value="value" :checked="defaultchecked === value">
            <span v-html="label"></span>
            <span class="checkmark"></span>
        </label>
    </div>
</template>

<script>
export default {
  inject: [
    'errors'
  ],
  props: {
    value: {
      required: true
    },
    label: {
      required: true
    },
    name: {
      required: true
    },
    type: {
      default: 'radio'
    },
    styleclass: {
      default: ''
    },
    required: {
      default: false
    },
    defaultchecked: {
      default: false
    }
  },
  data () {
    return {
      val: this.value
    }
  },
  methods: {
    change () {
      this.$emit('input', this.val)
    }
  }
}
</script>

<style lang="scss" scoped>
    .input-wrapper {
        &.error {
            input {
                border-color: #c2063b;
            }
        }

        .error-msg {
            color: #c2063b;
            font-size: 15px;
        }
    }
</style>
